import Vue from 'vue'
import Router from "vue-router"
import Body from '@/components/body'
import Login from '@/components/Login.vue'
import {
  store
} from "@/store";

//default pages
import pwReset from '@/pages/resetPassword.vue'
import forgotPassword from '@/pages/forgotPassword.vue'


//admin pages
import AdminDashboard from '@/pages/admin/AdminDashboard.vue'
import AdminEditProfile from '@/pages/admin/edit-profile.vue'
import AdminBauprojekte from '@/pages/admin/Bauprojekte.vue'
import AdminKunden from '@/pages/admin/Kunden.vue'
import AdminDienstleister from '@/pages/admin/Dienstleister.vue'
import AdminNachrichten from '@/pages/admin/Nachrichten.vue'
import AdminHilfe from '@/pages/admin/Hilfe.vue'
import AdminBauprojekt from '@/pages/admin/AdminBauprojekt.vue'
import AdminEditKunde from '@/pages/admin/AdminEditKunde.vue'
import AdminNewKunde from '@/pages/admin/AdminNewKunde.vue'
import AdminEditDienstleister from '@/pages/admin/AdminEditDienstleister.vue'
import AdminWohnungNew from '@/pages/admin/AdminWohnungNew.vue'
import AdminEditWohnung from '@/pages/admin/AdminEditWohnung.vue'
import AdminMeldungen from '@/pages/admin/AdminMeldungen.vue'
import KundeDashboard from '@/pages/kunde/KundeDashboard.vue'
import BodyKunde from '@/components/bodyKunde.vue'
import KundeWohnung from '@/pages/kunde/KundeWohnung.vue'
import KundeHilfe from "@/pages/kunde/KundeHilfe.vue"
import AdminAusstattungen from "@/pages/admin/AdminAusstattungen.vue"
import KundeProfile from "@/pages/kunde/KundeProfile.vue"
import permissionDenied from "@/pages/kunde/permissionDenied.vue"
import KundeWohnungOverview from "@/pages/kunde/KundeWohnungOverview.vue"
import AdminBenutzer from "@/pages/admin/Benutzer.vue";

// component
Vue.use(Router)

const isAdmin = async (to, from, next) => {
  const isAdmin = store.getters["auth/isAdmin"];
  if (!isAdmin) {
    next(-1);
  } else {
    next();
  }
}

const hasPermission = async (to, from, next) => {
  const kuwo = store.getters["app/kuwo"];
  if (to.name == "wohnung-detail") {
    const hasPermission = kuwo.find(kuwo => kuwo.id == to.params.wohnung_id) !== undefined ? true : false;
    console.log(hasPermission);
  }

  next();
}

const routes = [{
  path: '',
  redirect: {
    name: 'Start'
  }
},
{
  path: '/pwReset',
  component: pwReset
},
{
  path: '/forgotPassword',
  component: forgotPassword
},
{
  //ADMIN Area
  path: '/admin',
  component: Body,
  beforeEnter: isAdmin,
  children: [{
    path: 'dashboard',
    name: 'admin-dashboard',
    component: AdminDashboard,
    beforeEnter: isAdmin,
    meta: {
      title: 'Home',
    }
  },
  {
    path: 'edit-profile',
    name: 'admin-edit-profile',
    component: AdminEditProfile,
    beforeEnter: isAdmin,
    meta: {
      title: 'Benutzerprofil editieren',
      breadcrumb: "Benutzer editieren",
    }
  },
  {
    path: 'dashboard/bauprojekte',
    name: 'admin-bauprojekte',
    component: AdminBauprojekte,
    beforeEnter: isAdmin,
    meta: {
      title: "Bauprojekte",
      breadcrumb: "Bauprojekte"
    }
  },
  {
    path: 'dashboard/kunden',
    name: 'admin-kunden',
    component: AdminKunden,
    beforeEnter: isAdmin,
    meta: {
      title: "Kunden",
      breadcrumb: "Kunden"
    }
  },
  {
    path: 'dashboard/dienstleister',
    name: 'admin-dienstleister',
    component: AdminDienstleister,
    beforeEnter: isAdmin,
    meta: {
      title: "Dienstleister",
      breadcrumb: "Dienstleister"
    }
  },
  {
    path: 'dashboard/benutzer',
    name: "admin-benutzer",
    component: AdminBenutzer,
    beforeEnter: isAdmin,
    meta: {
      title: "Benutzer",
      breadcrumb: "Benutzer"
    }
  },
  {
    path: 'dashboard/nachrichten',
    name: 'admin-nachrichten',
    component: AdminNachrichten,
    beforeEnter: isAdmin,
    meta: {
      title: "Nachrichten",
      breadcrumb: "Nachrichten"
    }
  },
  {
    path: 'dashboard/hilfe',
    name: 'admin-hilfe',
    component: AdminHilfe,
    beforeEnter: isAdmin,
    meta: {
      title: "Hilfe",
      breadcrumb: "Hilfe"

    }
  },
  {
    path: 'dashboard/bauprojekte/new',
    name: 'new-bauprojekt',
    component: AdminBauprojekt,
    beforeEnter: isAdmin,
    meta: {
      title: "Neues Bauprojekt",
      breadcrumb: "Neues Bauprojekte"
    }
  },
  {
    path: 'dashboard/bauprojekte/:bauprojekt_id',
    name: 'admin-bauprojekt-detail',
    component: AdminBauprojekt,
    beforeEnter: isAdmin,
    meta: {
      title: "Bauprojekt Detail",
      breadcrumb: "Bauprojekt Detailseite"

    }
  },
  {
    path: 'dashboard/kunde/:kunde_id',
    name: 'admin-kunde-edit',
    component: AdminEditKunde,
    beforeEnter: isAdmin,
    meta: {
      title: "Kunde Detail",
      breadcrumb: "Kunde Detail"
    }
  },
  {
    path: 'dashboard/kunden/neu',
    name: 'admin-kunde-neu',
    component: AdminNewKunde,
    beforeEnter: isAdmin,
    meta: {
      title: "Neuer Kunde",
      breadcrumb: "Neuer Kunde"
    }
  },
  {
    path: 'dashboard/dienstleister/:dienstleister_id',
    name: 'admin-edit-dienstleister',
    component: AdminEditDienstleister,
    beforeEnter: isAdmin,
    meta: {
      title: "Dienstleister bearbeiten",
      breadcrumb: "Dienstleister bearbeiten"
    }
  },
  {
    path: 'dashboard/bauprojekte/:bauprojekt_id/haus/:haus_id/wohnung/neu',
    name: 'admin-bauprojekt-haus-wohnung-neu',
    component: AdminWohnungNew,
    beforeEnter: isAdmin,
    meta: {
      title: "Neue Wohnung erstellen",
      breadcrumb: "Neue Wohnung"
    }
  },
  {
    path: 'dashboard/bauprojekte/:bauprojekt_id/haus/:haus_id/wohnung/:wohnung_id',
    name: 'admin-edit-wohnung',
    component: AdminEditWohnung,
    beforeEnter: isAdmin,
    meta: {
      title: "Wohnung bearbeiten",
      breadcrumb: "Wohnung bearbeiten"
    }
  },
  {
    path: 'dashboard/meldungen',
    name: 'admin-meldungen',
    component: AdminMeldungen,
    beforeEnter: isAdmin,
    meta: {
      title: "Benachrichtigungen",
      breadcrumb: "Benachrichtigungen"
    }
  },
  {
    path: 'dashboard/Ausstattung',
    name: "admin-ausstattung",
    component: AdminAusstattungen,
    beforeEnter: isAdmin,
    meta: {
      title: "Ausstattungen",
      breadcrumb: "Ausstattungen"
    }
  }
  ],
},
{
  path: '/kunde',
  component: BodyKunde,
  beforeEnter: hasPermission,
  children: [{
    path: 'dashboard',
    name: 'kunde-dashboard',
    component: KundeDashboard,
    meta: {
      title: 'Home',
    }
  },
  {
    path: 'hilfe',
    name: 'kunde-hilfe',
    component: KundeHilfe,
    meta: {
      title: "Hilfe",
      breadcrumb: "Hilfe"

    }
  },
  {
    path: 'nachrichten',
    name: 'kunde-nachrichten',
    component: AdminNachrichten,
    meta: {
      title: "Nachrichten",
      breadcrumb: "Nachrichten"
    }
  },
  {
    path: 'wohnung/:wohnung_id',
    name: 'wohnung-detail',
    component: KundeWohnung,
    beforeEnter: hasPermission,
    meta: {
      title: "Wohnung Detail",
      breadcrumb: "Wohnung Detail"
    }
  },
  {
    path: 'wohnungen',
    name: 'kunde-wohnungen',
    component: KundeWohnungOverview,
    beforeEnter: hasPermission,
    meta: {
      title: "Wohnungsübersicht",
      breadcrumb: "Wohnungen"
    }
  },
  {
    path: 'kunde/profil',
    name: 'kunde-edit-profile',
    component: KundeProfile,
    meta: {
      title: "Kundenprofil editieren",
      breadcrumb: "Kundenprofil"
    }
  },
  {
    path: 'permissionDenied',
    name: 'kunde-permission-denied',
    component: permissionDenied,
    meta: {
      title: "Zugriff verweigert",
      breadcrumb: "Zugriff verweigert"
    }
  }
  ]
},

{
  path: '/',
  name: 'Start',
  component: Login
}
];


const router = new Router({
  routes,
  base: '/',
  mode: 'history',
  linkActiveClass: "active",
  scrollBehavior() {
    return {
      x: 0,
      y: 0
    }
  }
});

export default router;

router.beforeEach(async (to, from, next) => {

  if (to.path !== "/" && to.path !== "/forgotPassword" && to.path !== "/pwReset") {
    let loggedIn = await store.dispatch('auth/checkIfLoggedIn');
    if (loggedIn) {
      next();
      return
    } else {
      console.log("Authcheck failed, sending you to the Login Page");
      next("/");
      return
    }
  }
  next();
})